module.exports = __webpack_public_path__ + "img/fish-2.1011cd59.png";